import { AppViewReceiverModel } from './AppViewReceiverModel';
import { RailgunBase } from '../../RailgunBase';

/**
 * AppViewReceiverUtil
 *
 * イベントの処理実体を配列として保持して
 * イベント発生時に、イベントデータと配列で判定して処理実体を特定する。
 *
 * 処理実体はクロージャーで設定されているので、実行は設定したコンポーネントに存在する。
 */
export class AppViewReceiverUtil extends RailgunBase {

	// どのreceiverに、どのクラスが入っているかのマッピング配列があればいい
	// Keyにクラスが含まれ重複しなので、receiverでくくる必要がなくなる
	// 全部のマッピングが入っている配列があればいい。
	private static EventProclist: any = []; // こいつにKey/Value式で、処理実体が入っている。

	/**
	 * setEventProcList
	 * イベントのArrayを貰って全部登録する。
	 * @param list 登録するイベントリスト
	 */
	public static setEventProcList( list: Array<Array<any>> ) {

		// イベントデータを配列でもらって、一括登録する
		list.forEach(
			(item) => {
				// key,methodName,method で入っている想定
				if ( item.length === 3 && item[0] && item[1] && item[2]) { // パラメータ３つないとダメ
					// 保持用データにパックにして、元の設定メソッドを呼ぶ
					const proc = {
						methodName: item[1],
						method: item[2]
					};
					this.settingEventProc( item[0], proc);
				}

			}
		);

		// sampleデータ
		// const targetDefinition = AppViewReceiverConst.General.View.AppMainViewComponent;
		// const eventList = [
		// 	[
		// 		targetDefinition,
		// 		targetDefinition.LoginSuccess,
		// 		this.changePopupLoginSuccess.bind(this)
		// 	],
		// 	[
		// 		targetDefinition,
		// 		targetDefinition.LoginForgotPassword,
		// 		this.LoginForgotPassword.bind(this)
		// 	]
		// ];


	}

	/**
	 * settingEventProc
	 *
	 * 処理実体の設定処理
	 * keyに定義クラスのクラス名区分、procに定義クラスの処理名称と処理実体をクロージャーで設定する。
	 * Key/Value式で配列にstaticで保持しておく。
	 *
	 * @param key 定義クラスのクラス名区分
	 * @param proc 定義クラスの処理名称と処理実体をクロージャーで設定
	 */
	public static settingEventProc(key: any, proc: { methodName: any; method: any}   ) {

		// 特定のキーで、配列にセット
		// データが重複している場合にexistDataにリストのProcObjectが設定される
		const existData = this.EventProclist.find( (obj: { key: any; value: { methodName: any } } ) => {
			// 定義クラスのクラス名区分と処理名称で判定して、一致した場合はそのオブジェクトを返す
			if (obj.key === key && obj.value.methodName === proc.methodName) {
				return obj;
			}
		});

		// イベントの処理実体を設定する
		if (existData) {
			// 重複するデータを上書き
			const index = this.EventProclist.indexOf(existData);
			this.EventProclist[index] = { key, value: proc};
		} else {
			// イベント実体の情報をリストの末尾に追加する
			this.EventProclist.push({ key, value: proc});
		}

	}



	/**
	 * execEventProc
	 *
	 * 処理の呼び出し
	 * イベント元から送られてくるモデルのデータを、定義クラスのクラス名区分と処理名称で判定して
	 * クロージャーで設定された処理実体を呼ぶ
	 *
	 * @param model AppViewReceiverModel
	 * @param data イベントで受け取ったデータ
	 */
	public static async execEventProc(model: AppViewReceiverModel, data: any): Promise<any> {

		// 自分のEventProclistをループで処理実体を探して実行する
		// AppViewReceiverUtil.EventProclist
		// console.log(model);

		// 比較して取得した実体オブジェクトからメソッド取り出してコールする
		let methodRet = null;
		await this.EventProclist.forEach( async (proc: { key: any; value: { methodName: any; method: any } }) => {

			// イベント元から渡された、「UI区分・継承関係」が設定された値を元に、どこで処理するかを判定する
			if (model.className === proc.key) {

				// イベント元から渡された、処理名称を元に処理実体を判定する
				// 一致しているメソッド名を判定
				if (model.methodName === proc.value.methodName) {
					// クロージャーとして設定された処理を呼び出して結果保持
					const method = proc.value.method;
					methodRet = await method(model.instance, data);
				}

			}

		});

		return methodRet;


	}

}
